export default "__VITE_ASSET__C3Cdtb4X__"